<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>
        <b-button
            size="lg"
            variant="success"
            block
            @click="startCreateResponse"
        >
            <transition name="fade-fast" mode="out-in">
                <span v-if="!loading" key="notLoading">{{ buttonText }}</span>
                <span v-else key="loading">
                    <b-spinner small></b-spinner>
                </span>
            </transition>
        </b-button>

        <b-modal
            id="create-portal-response-problem-modal"
            centered
            hide-header
            size="sm"
            ok-only
            @hidden="onProblemModalHidden"
        >
            <h5>Could not start a response for the following reasons:</h5>
            <div>
                <p
                    v-for="errMsg in apiErrorsList"
                    :key="errMsg"
                    class="text-danger"
                >
                    {{ errMsg }}
                </p>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';

export default {
    name: 'PortalCreateRfxResponse',
    components: {},
    props: {
        rfxId: {
            type: [String, Number],
            required: true,
        },
        buttonText: {
            type: String,
            default: 'Respond Now',
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            apiErrors: {},  // if we get errors back from serializer, stash here
            // these errors will be a single Object/Dict, with keys for each field + 'non_field_errors'
            // the values will be a list/array of strings -- likely a single string in a list for each field, but maybe more
        }
    },
    computed: {
        apiErrorsList: function() {
            // this just returns a SINGLE ARRAY of strings from all the apiErrors... not in an object, 
            // just display them with a v-for in modal
            if (!this.apiErrors) return [];  // just return empty array if apiErrors got blasted
            return Object.values(this.apiErrors).flat();  // tested it, its safe even if apiErrors is empty object
        },
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        startCreateResponse: function() {
            // hit API to create a new response.
            // if successful, redirect to response URL
            // if not successful, show modal with errors
            this.loading = true;
            return suppliosApi.rfx.createPortalResponse(this.rfxId)
                .then(response => {
                    if (response.data.vendor_response_url) {
                        // make sure we have the URL to redirect to, then pass to handle method
                        this.handleCreateSuccess(response.data);
                        return true;
                    } else {
                        let noUrlData = {
                            noUrl: ['The response could not be created.  Please contact Support. (no response URL) '],
                        };
                        this.handleProblem(noUrlData);
                        return false;
                    }
                })
                .catch(error => {
                    // this.handleError(error, 'Error while starting your response.  Please contact support.')
                    // skipping our normal error handler and showing specific messages to user in modal
                    this.handleProblem(error.response.data);  
                    return false;
                })
                .then(success => {
                    this.loading = false;
                    return success;
                });
        },
        handleCreateSuccess: function(newRespData) {
            let redirectUrl = newRespData.vendor_response_url;
            // we should have already verified the URL exists before passing in here...
            window.location.href = redirectUrl;  // THE REDIRECT
        },
        handleProblem: function(problemData) {
            // if we get errors back from serializer, or didn't have URL, pass that here
            // show modal to explain problems
            this.apiErrors = problemData;
            this.$nextTick(() => {  // put in nextTick to make sure data is updated, including computed data
                this.$bvModal.show('create-portal-response-problem-modal');
            });
        },
        onProblemModalHidden: function() {
            this.apiErrors = {};  // reset our errors
        },

    }
}
</script>

<style>

</style>